import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

export class PasswordValidation {

  static SpecialSymbols(): ValidatorFn {
    return (ac: AbstractControl): {[key: string]: any} => {
      const value = ac.value;
      const lowercaseInvalid = !(/[a-z]/.test(value)); // doesn't contain lowercase letters
      const uppercaseInvalid = !(/[A-Z]/.test(value)); // doesn't contain uppercase letters
      const numbersInvalid = !(/[0-9]/.test(value)); // doesn't contain numbers
      const specialInvalid = !value.match(/[!@#$%^&*]/); // doesn't contain special characters
      if (lowercaseInvalid || uppercaseInvalid || numbersInvalid || specialInvalid) {
        return { notContainSpecial: true };
      } else {
        return null;
      }
    };
  }
}
